import React, { Component } from "react";

class Button extends Component {
  render() {
    // destructuring props
    const {
      text = "En savoir plus",
      color = "prospectionOrange",
      size = "btn-lg",
      href = "https://prospection.qc.ca/contact"
    } = this.props;
    const btnStyle = {
      textTransform: "uppercase",
      borderRadius: 0,
      marginTop: "20px",
      marginBottom: "20px"
    };
    return (
      <a
        style={btnStyle}
        className={`btn ${color} ${size} `}
        href={href}
        role="button"
      >
        {text}
      </a>
    );
  }
}

export default Button;
